import React, { useState, useEffect } from 'react'
import { useInView } from "react-intersection-observer";

import "./Visa.css"

import Button from "../Util/Button"
import Logo from "../Util/Logo"

import {ReactComponent as Close} from "../assets/icons/close.svg"
import {ReactComponent as Group} from "../assets/icons/group.svg"
import {ReactComponent as Checkbox} from "../assets/icons/checkbox.svg"
import {ReactComponent as Trophy} from "../assets/icons/trophy.svg"
import {ReactComponent as Information} from "../assets/icons/information.svg"
import classNames from 'classnames'

const Visa = () => {
    const [openType, setOpenType] = useState(-1)
    const { ref, inView } = useInView({ triggerOnce: false });

    /* Body-Scroll sperren und Escape zum Schließen, solange das Modal offen ist */
    useEffect(() => {
        if (openType === -1) return;

        document.body.style.overflow = 'hidden';
        const onKey = (e) => { if (e.key === 'Escape') setOpenType(-1); };
        window.addEventListener('keydown', onKey);

        return () => {
            document.body.style.overflow = '';
            window.removeEventListener('keydown', onKey);
        };
    }, [openType]);

    const VisaType = ({id, img, heading}) => (
        <div
            className='card'
            onClick={() => setOpenType(id)}
            role='button'
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setOpenType(id); } }}
        >
            <img src={img} alt="" loading="lazy" decoding="async" />
            <h2>{heading}</h2>
        </div>
    )


    return ( <div className='visa'>
        <section className='start'>

            <div className='hero-text'>
                <Logo/>
                <span className='bar' aria-hidden='true' />
                <h1>德国签证与移民</h1>
            </div>

            <div className='img-wrapper'>
                <img src='./images/visa.webp' alt='' loading='eager' decoding='async' />
            </div>
        </section>

        <section className='visa-types'>

            <h2>德国签证与移民</h2>

            <div className={classNames('visa-modal', {'open' : openType !== -1})} role="dialog" aria-modal="true">

                <div className='backdrop' onClick={() => setOpenType(-1)} />

                <div className='dialog'>
                        <Close className="close-btn" onClick={() => {setOpenType(-1)}}/>

                        <div className='dialog-body scrollbar-light'>
                            {openType === 0 && <>
                                <h2>德国留学签证</h2>
                                <p className='head'><Group/>适合人群</p>
                                <p className='bullet-point'>想通过学习进入德国并积累本地经验的年轻人</p>

                                <p className='head'><Checkbox/>基本要求</p>
                                <p className='bullet-point'>有德国大学或大学预备语言班的录取通知书</p>
                                <p className='bullet-point'>提供至少一年的资金证明 （ 2025年标准：13092欧元） </p>
                                <p className='bullet-point'>授课语言的语言水平证明 + 留德人员审核部（APS）证书</p>

                                <p className='head'><Trophy/>优点</p>
                                <p className='bullet-point'>低成本留学：公立大学免学费（少数联邦州除外），经济压力小，且可通过兼职赚取生活费</p>
                                <p className='bullet-point'>国际化程度高：师生来自全球，英语授课项目不断增加，为国际学生提供优质学习环境</p>
                                <p className='bullet-point'>优质生活环境：德国社会稳定、医疗健全、留学生福利多，生活成本合理</p>
                                <p className='bullet-point'>全球认可文凭：德国学位在全球具有较强竞争力，含金量高</p>
                                <p className='bullet-point'>就业前景广阔：毕业后可申请18个月工作签证，并有机会获得长期居留或移民</p>

                                <p className='head'><Information/>备注</p>
                                <p className='bullet-point'>醒狮中德商联提供留学规划咨询，帮助学员选择专业和院校，指导签证材料准备</p>
                                <p className='bullet-point'>提供入德后落地服务，包括接机、找房、落户、医保和银行卡开户等</p>
                                <Button to="/contact" filled>联系我们</Button>
                            </>}

                            {openType === 1 && <>
                                <h2>德语语言班签证</h2>
                                <p className='head'><Group/>适合人群</p>
                                <p className='bullet-point'>未来计划申请德国大学</p>
                                <p className='bullet-point'>职业培训或工作签证人</p>
                                <p className='bullet-point'>但德语尚未达到要求的人</p>

                                <p className='head'><Checkbox/>基本要求</p>
                                <p className='bullet-point'>课程要求：报名全日制德语课程（每周至少18-20课时，至少3个月）</p>
                                <p className='bullet-point'>经济保障：需提供封闭账户（每月至少 1091 欧元）或经济担保 </p>
                                <p className='bullet-point'>住宿安排：需提供住宿证明（租房合同或寄宿安排）</p>
                                <p className='bullet-point'>医疗保险：需购买符合德国要求的医疗保险</p>

                                <p className='head'><Trophy/>优点</p>
                                <p className='bullet-point'>语言能力：无最低语言要求，可从零基础开始</p>
                                <p className='bullet-point'>灵活学习：可在德国沉浸式学习德语，提高听说能力</p>
                                <p className='bullet-point'>签证时间长：最长可达12个月，时间充足</p>
                                <p className='bullet-point'>文化融入：提前适应德国的生活和学习环境，为未来发展奠定基础</p>
                                <p className='bullet-point'>后续发展：完成语言班后，可申请大学、职业培训或工作签证</p>

                                <p className='head'><Information/>备注</p>
                                <p className='bullet-point'>醒狮中德商联可根据学员需求，提供全日制德语课程报名及德国住宿安排服务</p>
                                <p className='bullet-point'>完成语言班后，大学签证可以直接在德国转换签证 (需大学录取证明)，职业培训签证及工作签证通常需回国重新申请</p>
                                <Button to="/contact" filled>联系我们</Button>
                            </>}

                            {openType === 2 && <> 
                                <h2>赴德读高中签证</h2>
                                <p className='head'><Group/> 适合人群</p>
                                <p className='bullet-point'>希望接受德国教育体系，并为未来考取德国大学做准备</p>
                                <p className='bullet-point'>家庭具备一定经济实力，能负担学费和生活费</p>

                                <p className='head'><Checkbox/> 基本要求</p>
                                <p className='bullet-point'>年龄：一般14-17岁</p>
                                <p className='bullet-point'>学校录取通知书：需提供德国中学出具的录取证明</p>
                                <p className='bullet-point'>住宿安排：提供寄宿学校证明或德国监护人安排</p>
                                <p className='bullet-point'>缴费证明：提供学校出具的首学年学费和寄宿费的缴费证明</p>
                                <p className='bullet-point'>经济担保：需提供封闭账户（2025年标准：13092欧元）或经济担保</p>
                                <p className='bullet-point'>医疗保险：须购买符合德国要求的健康保险</p>

                                <p className='head'><Trophy/> 优点</p>
                                <p className='bullet-point'>优质教育：享受德国免费或低成本的高质量中学教育</p>
                                <p className='bullet-point'>升学机会：毕业后可申请德国大学，免去APS审核</p>
                                <p className='bullet-point'>文化融入：提前适应德国语言、学习环境和社会</p>
                                <p className='bullet-point'>长远规划：为未来德国留学、就业和移民打下基础</p>

                                <p className='head'><Information/>备注</p>
                                <p className='bullet-point'>醒狮中德商联可根据学员需求，协助取得德国学校录取通知书及入德后落地服务</p>
                                <p className='bullet-point'>如果入学前需要参加超过 90天的德语语言课程 ，则只能先申请语言班签证</p>
                                <Button to="/contact" filled>联系我们</Button>
                            </>}

                            {openType === 3 && <> 
                                <h2>德国双元制职业培训签证</h2>
                                <p className='head'><Group/>适合人群</p>
                                <p className='bullet-point'>适合希望低成本进入德国长期工作的人，尤其是技术或服务行业</p>

                                <p className='head'><Checkbox/>基本要求</p>
                                <p className='bullet-point'>培训合同：须由德国企业或职业学校提供</p>
                                <p className='bullet-point'>语言能力： 专业职业培训至少B1，部分岗位可接受A2</p>
                                <p className='bullet-point'>学历要求：高中或同等学历，要求相对较低</p>

                                <p className='head'><Trophy/>优点</p>
                                <p className='bullet-point'>带薪培训：享受免费教育，并获得企业提供的带薪实习</p>
                                <p className='bullet-point'>稳定发展：在德国学习和工作满5年可申请永久居留</p>
                                <p className='bullet-point'>社会福利：享受免费医疗、社会保险等完善的保障体系</p>

                                <p className='head'><Information/>备注</p>
                                <p className='bullet-point'>德国双元制职业培训为18至35岁、学历要求较低的学员提供留学+就业一体化的发展路径</p>
                                <p className='bullet-point'>学员通过德语B1考试后，醒狮中德商联将根据其专业背景，协助申请德国企业的职业培训岗位</p>
                                <Button to="/contact" filled>联系我们</Button>                                
                            </>}

                            {openType === 4 && <> 
                                <h2>护理人员签证</h2>
                                <p className='head'><Group/>适合人群</p>
                                <p className='bullet-point'>护理专业毕业生，希望在德国从事护理工作</p>
                                <p className='bullet-point'>有护理经验，持有护士资格证书，并希望在德国发展职业生涯</p>
                                <p className='bullet-point'>愿意学习德语，适应德国医疗体系和工作环境</p>

                                <p className='head'><Checkbox/>基本要求</p>
                                <p className='bullet-point'>学历要求：中国护理或护士专业毕业证书 (也可前往德国接受培训成为护理人员)</p>
                                <p className='bullet-point'>资格认证：需通过德国护理资质认可</p>
                                <p className='bullet-point'>语言能力：至少B1级德语（部分州要求B2）</p>
                                <p className='bullet-point'>工作合同：须有德国雇主提供的正式护理工作合同 </p>
                                <p className='bullet-point'>资金证明：如已签订合同，一般无需额外存款证明</p>
                                <p className='bullet-point'>医疗保险：需购买符合德国要求的健康保险</p>

                                <p className='head'><Trophy/>优点</p>
                                <p className='bullet-point'>高薪稳定：护理行业需求量大，薪资稳定，待遇优厚</p>
                                <p className='bullet-point'>移民机会：工作满5年可申请德国永久居留</p>
                                <p className='bullet-point'>社会保障完善：享受德国医疗、社保及养老保险等福利</p>
                                <p className='bullet-point'>职业发展空间大：可进修专科护理、护理管理等，提升职业水平</p>

                                <p className='head'><Information/>备注</p>
                                <p className='bullet-point'>醒狮中德商联可协助学员取得德国职业资质认可证明，并对接德国雇主，帮助获取正式护理工作合同，助力顺利赴德就业</p>
                                <p className='bullet-point'>德国护理行业长期紧缺人才，适合希望稳定就业并长期发展的护理人</p>
                                <Button to="/contact" filled>联系我们</Button>                            
                            </>}

                            {openType === 5 && <> 
                                <h2>中国厨师签证</h2>
                                <p className='head'><Group/>适合人群</p>
                                <p className='bullet-point'>中餐厨师（擅长川菜、粤菜、湘菜等中国菜系）</p>
                                <p className='bullet-point'>有多年厨师经验，希望赴德从事餐饮行业</p>

                                <p className='head'><Checkbox/>基本要求</p>
                                <p className='bullet-point'>工作经验：一般需2年以上中餐厨师经验</p>
                                <p className='bullet-point'>技能证明：持有厨师资格证，并完成不少于2年的职业培训</p>
                                <p className='bullet-point'>工作合同：需有德国中餐馆正式聘用合同</p>
                                <p className='bullet-point'>外派劳务培训：具备外派劳务培训合格证</p>
                                <p className='bullet-point'>北京、上海或广州三所烹饪学校之一出具的在有效期内的卫生考试证书 & 烹饪考试证书</p>
                                <p className='bullet-point'>医疗保险：须购买符合德国要求的健康保险</p>

                                <p className='head'><Trophy/>优点</p>
                                <p className='bullet-point'>高需求：德国中餐行业发展迅速，厨师人才紧缺，工作机会多</p>
                                <p className='bullet-point'>薪资优厚：收入高于国内，并享受德国社保、医保等完善福利</p>
                                <p className='bullet-point'>职业前景广阔：工作满5年，可申请德国永久居留</p>
                                <p className='bullet-point'>家属团聚：符合条件后，可申请配偶及子女赴德</p>

                                <p className='head'><Information/>备注</p>
                                <p className='bullet-point'>醒狮中德商联可协助厨师匹配雇主、获取职业资质认可，助力顺利赴德工作</p>
                                <Button to="/contact" filled>联系我们</Button>
                            </>}

                            {openType === 6 && <> 
                                <h2>德国工作签证 (欧盟蓝卡签证)</h2>
                                <p className='head'><Group/>适合人群</p>
                                <p className='bullet-point'>具备高等学历或专业技能，有德国公司提供工作合同的人。</p>

                                <p className='head'><Checkbox/>基本要求</p>
                                <p className='bullet-point'>拥有德国认可的中国大学学位（等同于德国标准的学位）或受过职业培训的专业人才（中国的职业资格需通过德国的资格认可程序）在德国短缺行业中找到工作（如IT、工程、护理、建筑、 物流、电气技术等领域）</p>
                                <p className='bullet-point'>工作合同年薪需达到一定标准（2025年蓝卡年薪标准为约 58400 欧元，短缺行业如IT、工程约为 45552 欧元）</p>
                                <p className='bullet-point'>年龄一般需在45岁以下（45岁以上申请人有最低薪资，2025年年薪标准为53130欧元或提供养老保障证明）</p>

                                <p className='head'><Trophy/>优点</p>
                                <p className='bullet-point'>审批快，办理时间短，不需要提供德语能力水平证明</p>
                                <p className='bullet-point'>配偶及未成年子女可一同申请家庭团聚签证</p>
                                <p className='bullet-point'>持蓝卡工作33个月（缴纳社会保险），或21个月（若通过B1德语考试）后可申请德国永久居留</p>

                                <p className='head'><Information/>备注</p>
                                <p className='bullet-point'>IT专业人才如无大学学历，但具三年相关经验者亦可获欧盟蓝卡</p>
                                <p className='bullet-point'>如果没有工作合同但希望来德国找工作，可申请德国“机会卡”签证，需提供确保在德国整个逗留期间经济来源的证明 (每月至少 1091 欧元) </p>
                                <p className='bullet-point'>醒狮中德商联协助您完成中国学历或职业资格的德国认证，并匹配合适的工作机会</p>
                                <Button to="/contact" filled>联系我们</Button>
                            </>}

                            {openType === 7 && <> 
                                <h2>在德国开设私营企业的签证 （法人签证）</h2>
                                <p className='head'><Group/>适合人群</p>
                                <p className='bullet-point'>有一定经济实力，希望通过投资获得居留许可的人</p>

                                <p className='head'><Checkbox/>基本要求</p>
                                <p className='bullet-point'>需在德国设立企业并满足一定的投资金额</p>
                                <p className='bullet-point'>申请人需具备一定企业经营管理经验 </p>

                                <p className='head'><Trophy/>优点</p>
                                <p className='bullet-point'>没有语言和学历要求</p>
                                <p className='bullet-point'>配偶及未成年子女可一同申请家庭团聚签证</p>
                                <p className='bullet-point'>公司按照商业计划书正常运营满3年后可申请永久居留 </p>

                                <p className='head'><Information/>备注</p>
                                <p className='bullet-point'>有限责任公司（GmbH）是德国最常见的公司形式，其最低注册资本要求为25000 欧元。股东对外不承担个人责任，公司仅以其资产为限对债务承担责任。此外，GmbH 账户中的注册资本不受冻结限制，可用于公司的日常运营和支出。</p>
                                <p className='bullet-point'>醒狮中德商联为投资者提供法人签证咨询及德国公司注册与落地服务的一站式解决方案。</p>
                                <Button to="/contact" filled>联系我们</Button>                            
                            </>}
                        </div>
                </div>
            </div>

            <div className='cards'>

                <VisaType id={0} heading="德国留学签证" img={'./images/visa-study.webp'}/>

                <VisaType id={1} heading="德语语言班签证" img={'./images/visa-language.webp'}/>

                <VisaType id={2} heading="赴德读高中签证" img={'./images/visa-school.webp'}/>
                
                <VisaType id={3} heading="德国双元制职业培训签证" img={'./images/visa-trainee.webp'}/>

                <VisaType id={4} heading="护理人员签证" img={'./images/nurse.webp'}/>

                <VisaType id={5} heading="中国厨师签证" img={'./images/visa-cook.webp'}/>

                <VisaType id={6} heading={<> 德国工作签证 <br/>(欧盟蓝卡签证)</>} img={'./images/construction.webp'}/>

                <VisaType id={7} heading={<> 在德国开设私营企业的签证 <br/>(法人签证)</>} img={'./images/visa-business.webp'}/>

            </div>

        </section>

        <section className='flow-chart'>
            <h2>德国留学签证— 申请赴德留学资格</h2>
            <div className={`grid scrollbar-x ${inView ? "in-view" : ""}`} ref={ref}>

                <div className='cell c1 r1 h4 w1'>直接进入 <br/> 德国大学</div>
                <div className='cell c1 r5'>通过预科申 <br/> 请德国大学</div>

                <div className='arrow c2 r1 h4 w1'></div>
                <div className='arrow c2 r5 h1 w1'></div>

                <div className='cell c3 r1 w1 h1'>博士阶段</div>
                <div className='cell c3 r2 w1 h1'>硕士阶段</div>
                <div className='cell c3 r3 w1 h1'>本科阶段</div>
                <div className='cell c3 r4 w1 h1'>2019年后 <br/> 参加高考</div>
                <div className='cell c3 r5 w3 h1'>在国内非211大学就读未满三 <br/> 个学期或者三年制大专毕业</div>

                <div className='arrow c4 r1 w1 h1'></div>
                <div className='arrow c4 r2 w1 h1'></div>
                <div className='arrow c4 r3 w1 h1'></div>
                <div className='arrow c4 r4 w1 h1'></div>

                <div className='cell c5 r1 w1 h1'>已获得国内公 <br/> 立大学本科文凭</div>
                <div className='cell c5 r2 w1 h1'>已获得国内公 <br/>  立大学本科文凭</div>
                <div className='cell c5 r3 w1 h1'>至少在国内普通大学 <br/> 修满三个学期或在 <br/> 211大学修满一个学期</div>
                <div className='cell c5 r4 w1 h1'>高考分数超过 <br/> 高考总分的70%</div>

                <div className='arrow c6 r1 w1 h1'></div>
                <div className='arrow c6 r2 h2 w1'></div>
                <div className='arrow c6 r4 w1 h1'></div>
                <div className='arrow c6 r5 w1 h1'></div>

                <div className='cell c7 r1 w1 h1'>获得德国大学教授或 <br/> 博士生院的邀请函</div>
                <div className='cell c7 r2 h2 w1'>APS审核和大 <br/>  学的语言要求</div>
                <div className='cell c7 r4 w1 h1'>大学语言要求 <br/>（免预科)<br/>(免APS考试)</div>
                <div className='cell c7 r5 w1 h1'>APS审核和大 <br/>学的语言要求</div>

                <div className='arrow c8 r1 w1 h1'></div>
                <div className='arrow c8 r2 h2 w1'></div>
                <div className='arrow c8 r4 w1 h1'></div>
                <div className='cell c8 r5 w1 h1'>12个月德国大学 <br/> 预科课程并通过 <br/> 入学鉴定考试</div>

                <div className='cell c9 r1 w1 h1'>进入博士阶段</div>
                <div className='cell c9 r2 w1 h1'>进入硕士阶段</div>
                <div className='cell c9 r3 h3 w1'> 进入德国大 <br/> 学本科阶段</div>

            </div>
        </section>
    </div> 
    );
}
 
export default Visa;